import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ILanguage } from '@app-core/interfaces/language.interface';
import {
  EmailLanguageType,
  IPreferredEmailLanguageResponse,
} from '@app-core/interfaces/preferred-email-language.interface';
import { LanguageRepository } from '@app-core/state/language.repository';
import { SessionRepository } from '@app-core/state/session.repository';
import { Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private readonly http = inject(HttpClient);
  private readonly languageRepo = inject(LanguageRepository);
  private readonly sessionRepo = inject(SessionRepository);

  /**
   * Gets a list of languages.
   *
   * GET /language
   */
  getAllLanguages(): Observable<ILanguage[]> {
    return this.http
      .get<ILanguage[]>(environment.apiUrl + `/language`)
      .pipe(tap(data => this.languageRepo.setLanguages(data)));
  }

  /**
   * Sets user's preferred email communication language.
   *
   * POST /email/change-language
   *
   * @param lang
   */
  setPreferredEmailLanguage(
    lang: EmailLanguageType,
  ): Observable<IPreferredEmailLanguageResponse> {
    return this.http
      .post<IPreferredEmailLanguageResponse>(
        environment.apiUrl + `/email/change-language`,
        { email_language: lang },
      )
      .pipe(
        tap(res => {
          const user = this.sessionRepo.getStoreProp('authUser');

          if (user) {
            this.sessionRepo.setStoreProp('authUser', {
              ...user,
              email_language: res.email_language,
            });
          }
        }),
      );
  }
}
